var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-per100 h400 column flex_center white_color",style:({backgroundImage: 'url('+ _vm.bg +')',backgroundSize: '100% 100%',backgroundRepeat: 'no-repeat'})})
}
var staticRenderFns = []

export { render, staticRenderFns }